import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", rotate }) => {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333252 6.80029C0.333252 8.39159 0.965393 9.91772 2.09061 11.0429C3.21583 12.1682 4.74195 12.8003 6.33325 12.8003C7.92659 12.8003 9.45325 12.1736 10.5999 11.067L9.59992 10.067C9.18006 10.5113 8.67355 10.8647 8.11168 11.1055C7.54982 11.3463 6.94454 11.4693 6.33325 11.467C2.17325 11.467 0.0932522 6.44029 3.03325 3.50029C5.97325 0.560293 10.9999 2.64696 10.9999 6.80029H8.99992L11.6666 9.46696H11.7333L14.3333 6.80029H12.3333C12.3333 5.20899 11.7011 3.68287 10.5759 2.55765C9.45067 1.43243 7.92455 0.800293 6.33325 0.800293C4.74195 0.800293 3.21583 1.43243 2.09061 2.55765C0.965393 3.68287 0.333252 5.20899 0.333252 6.80029Z"
        fill={fill}
      />
    </svg>
  );
};

export default memo(Icon);
